import { Reveal, SectionHead } from "./Reveal";

const POINTS = [
    "A randomized trial in Sweden with 200 adults over 65 found that participants learned safer falling techniques with no adverse effects and kept the skills 20 months later.",
    "A major review of 108 studies (Cochrane, 2019) found that exercise reduces the rate of falls in older adults by about 23%, with the strongest evidence for balance and functional training.",
    "Programs teaching judo-based safe landing to older adults are growing in Australia, Europe and Asia. Fall Safe Ready brings this approach to Northern Virginia.",
];

export default function Research() {
    return (
        <section className="border-y border-clay bg-sand py-10 sm:py-14 lg:py-28">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal>
                    <SectionHead eyebrow="Evidence" title="Grounded in research" />
                </Reveal>
                <div className="mt-8 grid sm:mt-12 gap-8 md:grid-cols-3">
                    {POINTS.map((p, i) => (
                        <Reveal key={i} delay={i * 0.1} className="h-full">
                            <div className="h-full border-t-2 border-teal-600 pt-6" data-testid={`research-point-${i + 1}`}>
                                <p className="text-lg leading-relaxed text-ink">{p}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}